import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAuth, IProfile } from '@/types';
import { StoreUtils, EKeyStore } from '@/utils/localStore';

interface IAuthState {
  auth: IAuth | null;
  myProfile: IProfile | null;
}

const initialState: IAuthState = {
  auth: StoreUtils.getObj<IAuth>(EKeyStore.Auth),
  myProfile: StoreUtils.getObj<IProfile>(EKeyStore.MyProfile),
};

const authAdminSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state: IAuthState, action: PayloadAction<IAuth>) => {
      const auth = action.payload;
      state.auth = auth;
      StoreUtils.setObj<IAuth>(EKeyStore.Auth, auth);
    },
    setMyProfile: (state: IAuthState, action: PayloadAction<IProfile>) => {
      const myProfile = action.payload;
      state.myProfile = myProfile;
      StoreUtils.setObj<IProfile>(EKeyStore.MyProfile, myProfile);
    },
    logout: (state: IAuthState) => {
      state.auth = null;
      localStorage.removeItem(EKeyStore.AccessToken);
      localStorage.removeItem(EKeyStore.Auth);
      localStorage.removeItem(EKeyStore.RefreshToken);
      localStorage.removeItem(EKeyStore.MyProfile);
    },
  },
});

export const { logout, setAuth, setMyProfile } = authAdminSlice.actions;

export default authAdminSlice.reducer;
